import React, { useContext, useEffect, useRef, useState } from 'react'
import StylesContext from '../context/StylesContext';
import { useHistory, useParams } from 'react-router-dom';
import api from '../api';
import MainContainer from '../components/MainContainer';
import StyledContainer from '../components/StyledContainer';
import StyledTitle from '../components/StyledTitle';
import useSessionStorage, { chartItemProps } from '../hooks/useSessionStorage';
import ChartCard from '../components/ChartCard';
import '../styles/Chart.css';
import ChartContext from '../context/ChartContext';
import VocalInterfaceContext from '../context/VocalInterfaceContext';
import TopText from '../components/TopText';
import useTextToSpeech from '../hooks/useTextToSpeech';
import audioBip from '../assets/audios/bip.mp3';
import useAudioRecorder from '../hooks/useAudioRecorder';
import { getItemNameForChart, itemListToArray } from '../helpers/extractItemName';
import Footer from '../components/Footer';

const ChartVocalInterface = () => {
  const { styles, setStyles } = useContext(StylesContext);
  const { getSessionStorage, addItemQuantity, removeItemQuantity, removeZeroQuantityItems } = useSessionStorage();
  const { menu } = useParams<{menu: string}>();
  const chartList: Array<chartItemProps> = getSessionStorage();
  const { chartTotal } = useContext(ChartContext);
  const { currentText, setCurrentText } = useContext(VocalInterfaceContext);
  const [ played, setPlayed ] = useState(false);
  const itemIndexRef = useRef(0);
  const audioRef = useRef<HTMLAudioElement>(null);
  const { textToSpeech } = useTextToSpeech(audioRef);
  const history = useHistory();
  const { startRecording } = useAudioRecorder();

  const handleClick = () => {
    setPlayed(false);
    removeZeroQuantityItems(chartList);
    textToSpeech(`Você tem o total de ${chartTotal.itemsTotal} itens no seu pedido, totalizando ${chartTotal.priceTotal.toFixed(2)} Reais. Para ouvir os itens do seu pedido diga itens. Para editar o pedido diga editar. Ou diga menu principal para voltar ao menu principal.`);
  };

  const handleAudioEnd = () => {
    if (!played) {
      setPlayed(true);
      if (audioRef.current) {
        audioRef.current.src = audioBip;
        audioRef.current.play()
          .then(() => {
            if (audioRef.current) {
              audioRef.current.onended = () => {
                startRecording();
              }
            }
          });
      };
    };
  };

  useEffect(() => {
    textToSpeech(`Você tem o total de ${chartTotal.itemsTotal} itens no seu pedido, totalizando ${chartTotal.priceTotal.toFixed(2)} Reais. Para ouvir os itens do seu pedido diga itens. Para editar o pedido diga editar. Ou diga menu principal para voltar ao menu principal.`);
  }, []);

  useEffect(() => {
    const getStyles = async () => {
      try {
        const { data } = await api.get(`menu_styles/${menu}`);
        setStyles(data);
      } catch(error: any) {
      console.error(error.message);
      }
    }
    getStyles();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu]);

  useEffect(() => {
    if (currentText !== '') {
      if (currentText === 'menu principal') {
        history.push(`/cardapio/${styles.urlId}/categoriesvocal`);
      } else if (currentText === 'itens') {
        const chartListString = getItemNameForChart(chartList);
        textToSpeech(`${chartListString}, totalizando ${chartTotal.priceTotal.toFixed(2)} reais.`, () => {
          setPlayed(false);
          textToSpeech('Para finalizar o pedido diga finalizar. Para editar o pedido diga editar. Para ouvir os itens novamente diga itens. Ou diga menu principal para retornar ao menu principal');
          setCurrentText('');
        });
      } else if (currentText === 'editar') {
        itemIndexRef.current = 0;
        removeZeroQuantityItems(chartList);
        
        const itemListArray = itemListToArray(chartList);
        setPlayed(false);
        if (chartList[itemIndexRef.current].quantity === 1) {
          textToSpeech(`${itemListArray[itemIndexRef.current]}. Para remover o item do pedido diga retirar. Para ouvir o próximo item diga próximo.`);
        } else {
          textToSpeech(`${itemListArray[itemIndexRef.current]}. Para retirar uma unidade diga retirar. Para ouvir o próximo item diga próximo.`);
        }
      } else if (currentText === 'próximo') {
        setCurrentText('');
        const itemListArray = itemListToArray(chartList);
        setPlayed(false);
        itemIndexRef.current += 1;        
        if (itemIndexRef.current >= itemListArray.length) {
          removeZeroQuantityItems(chartList);
          textToSpeech('Você ouviu todos os itens do pedido. Para finalizar o pedido diga finalizar. Para revisar e ouvir os itens do seu pedido diga itens. Para retornar ao menu principal diga menu principal.');
        } else {
          if (chartList[itemIndexRef.current].quantity === 1) {
            textToSpeech(`${itemListArray[itemIndexRef.current]}. Para remover do pedido diga retirar. Para ouvir o próximo item diga próximo.`);
          } else {      
            textToSpeech(`${itemListArray[itemIndexRef.current]}. Para retirar uma unidade diga retirar. Para ouvir o próximo item diga próximo.`);            
          }
        };
      } else if (currentText === 'retirar') {
        setPlayed(false);
        setCurrentText('');
        removeItemQuantity(chartList[itemIndexRef.current].itemName, chartList[itemIndexRef.current].itemPrice, chartList[itemIndexRef.current].quantity);
        if (chartList[itemIndexRef.current].quantity === 1) {
          textToSpeech('Item removido do pedido. Para ouvir o próximo item diga próximo. Para finalizar o pedido diga finalizar. Para revisar e ouvir os itens do seu pedido diga itens.')
        } else {
          textToSpeech(`Uma unidade de ${chartList[itemIndexRef.current].itemName} removida. Para ouvir o próximo item diga próximo. Para finalizar o pedido diga finalizar. Para revisar e ouvir os itens do seu pedido diga itens.`);
        }       
      } else if (currentText === 'finalizar') {
        textToSpeech('Pedido finalizado.'); 
      } else {
        setCurrentText('');
        textToSpeech('Comando inválido. Toque na parte superior da tela para continuar.')
      };
    };
  }, [currentText]);

  return (
    <MainContainer className='chart_main_container' $backgroundColor={styles.bgColor}>
      <StyledContainer className='top_text_wrapper' onClick={handleClick}>
        <TopText  />
        <StyledContainer className='chart_container_title_icon'>
          <StyledContainer className='icon_wrapper'>
            <svg viewBox="0 0 50 60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M33.6912 41.034C35.5401 40.2647 37.3505 39.5125 39.161 38.7589C40.5601 38.1772 41.9536 37.5841 43.357 37.0139C45.7439 36.0439 48.2931 37.0067 49.3976 39.2818C50.4836 41.5183 49.6652 44.1731 47.4305 45.4167C40.5929 49.2191 33.7395 52.9942 26.8862 56.7665C26.6756 56.8826 26.3952 56.9112 26.1475 56.9112C21.6 56.9198 17.051 56.917 12.5021 56.917H11.8544V59.9973H2.56152V36.6199C2.75937 36.6199 2.95863 36.6199 3.15932 36.6199C11.6352 36.6199 20.1126 36.6199 28.5885 36.6199C31.3911 36.6199 33.109 38.0497 33.6314 40.8163C33.6413 40.8664 33.6584 40.9151 33.6912 41.034ZM15.8782 42.865C17.8025 42.865 19.6771 42.865 21.553 42.865C23.9826 42.865 26.4108 42.8607 28.8404 42.8679C29.5663 42.8693 30.1186 42.5813 30.4146 41.9094C30.8858 40.8406 30.0859 39.7503 28.8376 39.7489C23.325 39.746 17.8125 39.7475 12.2999 39.7489C12.1519 39.7489 12.0039 39.7675 11.8616 39.7776V53.7937H12.2871C16.6795 53.7937 21.0733 53.798 25.4657 53.7836C25.739 53.7836 26.0379 53.6748 26.2827 53.5401C30.4061 51.275 34.5224 48.997 38.6386 46.7204C41.0213 45.4038 43.4054 44.0871 45.7866 42.7662C46.5637 42.3349 46.8883 41.7031 46.7217 40.9868C46.4869 39.9724 45.5233 39.4953 44.5028 39.9194C40.0349 41.7733 35.5699 43.6329 31.1078 45.5012C30.3164 45.8336 29.5094 45.9983 28.6497 45.9969C24.5847 45.9855 20.5182 45.9912 16.4532 45.9912H15.8796V42.865H15.8782ZM8.69465 56.9012V39.7876H5.67292V56.9012H8.69465Z" fill={styles.btnBgColor || "#553839"}/>
              <path d="M46.4413 25.0339C47.4512 25.0264 48.3145 25.3038 49.0123 26.0007C49.6325 26.6197 49.9671 27.3718 49.9846 28.2482C50.0021 29.1045 50.0084 29.9621 49.9833 30.8184C49.932 32.5336 48.5475 33.9536 46.8385 33.9775C44.3101 34.0126 41.7805 34.0001 39.2521 33.9838C38.2522 33.9775 37.488 33.1651 37.493 32.1895C37.498 31.2114 38.2623 30.4242 39.2709 30.4166C41.4271 30.4003 43.5847 30.4116 45.7422 30.4116C45.9439 30.4116 46.1456 30.4116 46.3812 30.4116V28.6538H3.61273V30.4116C3.83825 30.4116 4.05501 30.4116 4.27302 30.4116C13.4406 30.4116 22.607 30.4116 31.7746 30.4116C31.9977 30.4116 32.2244 30.4003 32.4424 30.438C33.337 30.5911 33.9798 31.4249 33.9184 32.3276C33.8582 33.2066 33.1403 33.9222 32.2482 33.9863C32.0816 33.9988 31.9137 33.9913 31.7458 33.9913C22.3928 33.9913 13.0397 33.9913 3.68665 33.9913C1.30735 33.9913 0.000556854 32.6792 0.000556854 30.2936C0.000556854 29.716 -0.000696067 29.1384 0.000556854 28.5609C0.00682146 26.4175 1.38002 25.0477 3.53505 25.0477C10.6203 25.0452 17.7043 25.0477 24.7896 25.0477C30.5731 25.0477 36.3553 25.0477 42.1388 25.0477C42.3581 25.0477 42.5786 25.0477 42.8367 25.0477C42.655 22.9571 42.135 21.0135 41.2831 19.1602C38.2623 12.5922 31.5992 8.37088 24.3999 8.78397C16.8423 9.21715 11.5124 13.0568 8.4916 20.0328C8.13452 20.8565 7.72607 21.5345 6.74127 21.586C5.40691 21.6551 4.51483 20.3781 5.01851 19.0974C7.14597 13.682 10.8483 9.73697 16.1231 7.30237C17.2458 6.78381 18.4398 6.41843 19.5712 5.99404C19.6539 5.34113 19.6714 4.66185 19.8343 4.02024C20.4833 1.45255 22.9666 -0.26008 25.5389 0.0324735C28.2439 0.340094 30.315 2.55371 30.3263 5.25575C30.3288 5.93879 30.5731 6.11458 31.1682 6.31547C39.8347 9.22594 44.904 15.2051 46.3273 24.2629C46.3649 24.5015 46.3975 24.7401 46.4401 25.0339H46.4413ZM23.236 5.31853H26.7692C26.6151 4.22993 25.8984 3.57576 24.95 3.58957C24.1794 3.59962 23.2335 4.25881 23.236 5.31853Z" fill={styles.btnBgColor || "#553839"}/>
            </svg>
          </StyledContainer>
          <StyledTitle
            className='chart_title_categories_list'
            $textColor={styles.textColor}
            >
              MEUS PEDIDOS
          </StyledTitle>
        </StyledContainer>
      </StyledContainer>
      <StyledContainer className='chart_items_card_container'>
        {
          chartList?.map(chartEl => (
            <ChartCard key={chartEl.itemName} menu_item={chartEl} showButtons={false} />
          ))
        }
      </StyledContainer>
      <StyledContainer $bgColor={styles.bgColor} className='chart_total_price'>
        <StyledTitle $textColor={styles.secondaryTextColor}>{`Total: R$ ${chartTotal.priceTotal.toFixed(2)}`}</StyledTitle>
      </StyledContainer>
      <Footer $footerLogoColor={ styles.footerColor } classCategories='footer-categories' />
      <audio ref={audioRef} onEnded={handleAudioEnd}/>
    </MainContainer>
  )
}

export default ChartVocalInterface;